import { action, observable } from 'mobx';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { OrderingDoctorEditModalForm } from 'application/facility-order/forms';
import { PatientService } from "application/patient/services";
import { DoctorService } from 'application/import/services';
import _ from 'lodash';

class OrderingDoctorEditModalViewStore extends BaseEditViewStore {      
    @observable accessor orderingDoctor = null;
    constructor(rootStore, componentProps) {
        const patientService = new PatientService(rootStore.application.baasic.apiClient);

        const patientKey = componentProps.modalParams.data.patientKey;

        super(rootStore, {
            name: 'ordering-doctor-edit-modal',
            Form: OrderingDoctorEditModalForm,
            id: patientKey,
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await patientService.get(id);

                        _.extend(response.data, {
                            ssn: response.data.patientGeneralInfo && response.data.patientGeneralInfo.ssn,
                            height: response.data.patientClinicalInfo && response.data.patientClinicalInfo.height,
                            weight: response.data.patientClinicalInfo && response.data.patientClinicalInfo.weight,      
                            orderingDoctor: response.data.patientClinicalInfo && response.data.patientClinicalInfo.orderingDoctor && response.data.patientClinicalInfo.orderingDoctor.doctor.value,
                            orderingDoctorId: response.data.patientClinicalInfo && response.data.patientClinicalInfo.orderingDoctor && response.data.patientClinicalInfo.orderingDoctor.doctor.id,
                        });
                        
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await patientService.updateOrderingDoctor(resource);

                        return response;
                    }
                }
            },
            FormClass: OrderingDoctorEditModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.refreshPatientData = componentProps.modalParams.data.refreshPatientData;
        this.orderingDoctorId = componentProps.modalParams.data.orderingDoctorId;
        this.orderingDoctor = componentProps.modalParams.data.orderingDoctor;
        this.doctorService = new DoctorService(rootStore.application.baasic.apiClient);
        this.doctorStore = this.constructDoctorDropdownsStore();
        this.patientKey = patientKey;
    }

    @action
    async setItem(item) {
        this.item = item;
		this.doctorStore.setValue({orderingDoctor: this.orderingDoctor, orderingDoctorId: this.orderingDoctorId});
    }

    @action.bound
    constructDoctorDropdownsStore() {
        return new BaasicDropdownStore({
            textField: 'orderingDoctor',
            dataItemKey: 'orderingDoctorId',
            filterable: true,
            returnObject: true
            }, {
            fetchFunc: async (term) => {
                const response = await this.doctorService.find({ searchQuery: term, rpp : 100 });
                _.extend(response.data,
                    {
                        item: _.map(response.data.item, (item => {
                            return _.extend(
                                item, {
                                    orderingDoctor: item.name + " - " + item.npi,
                                    orderingDoctorId: item.id         
                                }
                            );
                        }))                         
                    });
                return response.data.item; 
            },
            onChange: (doctor) => {
                this.form.set({ orderingDoctor: doctor.orderingDoctor, orderingDoctorId: doctor.orderingDoctorId });
            }
        });
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                patientBrightreeId: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            this.modalParams.close();
            await this.refreshPatientData(this.patientKey);

            await setTimeout(() => this.rootStore.notificationStore.success("TEMPLATES.ORDERING_DOCTOR.EDIT"));
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default OrderingDoctorEditModalViewStore;
